var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"jsoneditor-vue"}),_vm._v(" "),(_vm.showBtns!==false)?_c('div',{staticClass:"jsoneditor-btns"},[_c('button',{staticClass:"json-save-btn",attrs:{"type":"button","disabled":_vm.error},on:{"click":function($event){return _vm.onSave()}}},[_vm._v(_vm._s(_vm.locale[_vm.lang].save))])]):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-723cff9b","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-json-editor/vue-json-editor.vue
// module id = null
// module chunks = 